/* @ngInject */
const metadata = (
  trainButtons,
  trainFields
) => {
  const self = {}

  self.favoriteSort = [
    'date',
  ]

  self.buttons = [
    trainButtons.search,
    trainButtons.edit,
    trainButtons.addWagon,
    trainButtons.removeWagon,
    trainButtons.delete,
  ]

  self.fields = trainFields

  return self
}

export default metadata



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/trains/train/services/metadata.service.js